type ReadOnlyToggleProps = {
  label: string
  checked: boolean
}

export const ReadOnlyToggle = ({ label, checked }: ReadOnlyToggleProps) => (
  <div className="flex items-center gap-3 py-1">
    <div
      className={`w-5 h-5 rounded-[4px] flex items-center justify-center shrink-0 ${
        checked ? "bg-[#7E7E85]" : "bg-neutral-op-8"
      }`}
    >
      {checked && <div className="w-2.5 h-2.5 bg-white rounded-sm" />}
    </div>
    <span className="text-[13px] text-gray-300">{label}</span>
  </div>
)

